<template>
    <div class="public-bck">
        <div class="proton-bck">
            <div class="bck-top"></div>
            <div class="proton-content" v-if="!getState">
                <p>恭喜你完成了任务</p>
                <p>快来领取奖励吧～</p>
                <div class="proton-img">
                    <img :src="proton" alt="">
                </div>
                <el-form ref="form" :model="form">
                    <div class="form-lable">手机号</div>
                    <div style="width: 100%;">
                    <div class="form_phone">
                        <div class="phone_pre">+86</div>
                        <div class="phone_input">
                                 <el-input v-model="form.phone" placeholder="请输入手机号"></el-input>
                        </div>
                        <div class="phone_clear" v-if="clearState" @click="form.phone = ''">
                        <img src="@/assets/img/coupon/collect_clear.png" alt />
                        </div>
                    </div>
                    <div class="warn" v-show="warn"><span>*</span>{{warn}}</div>
                    </div>
                </el-form>
                 <el-button type="warning" @click="getProton" :style="warn?'':'margin-top:16px;'">点我领取</el-button>
            </div>
            <!-- 领取成功 -->
            <div class="proton-getsuccess" v-else>
                <p>恭喜获得质子</p>
                <div class="proton-img">
                    <img :src="success_proton" alt="" >
                    <h1>+{{protonNumber}}</h1>
                    <h2>已领取成功</h2>
                    <p>您可以在「质心官网」或「质心在线」App中</p>
                    <p>查看自己获得的质子奖励。</p>
                </div>
            </div>
            <div class="proton-content-bottom">
                <div class="tip-top">获取和使用说明</div>
                <div v-for="(item ,index) in tips" :key="index" class="tip-lists">
                    {{item.title}}
                    <div class="tip-tipsinfo" v-for="(obj,k) in item.content" :key="k">{{k+1}}.{{obj}}</div>
                </div>
            </div>
        </div>
        <div class="noregister" v-if="isRegister">
            <div class="noregister-pop">
                <div>
                    <img :src="noregister" alt="" class="noregister-img">
                    <img src="@/assets/img/public/proton/close@2x.png" alt="" @click="isRegister=false"  class="noregister-close-img">
                </div>
                <div class="noregister-content">
                    <p>该手机号尚未注册</p>
                    <p>请前往「质心教育」官网注册</p>
                    <a :href="zhixinUrl" target="_blank"><p>点击前往</p></a>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import $ from 'jquery'
import api from '@/api'

export default {
  data () {
    return {
      zhixinUrl: '',
      getState: false,
      clearState: false,
      isRegister: false,
      protonNumber: 0,
      proton: require('@/assets/img/public/proton/stars@3x.png'),
      success_proton: require('@/assets/img/public/proton/success_stars@3x.png'),
      noregister: require('@/assets/img/public/proton/noregister_top@2x.png'),
      form: {
        phone: ''
      },
      tips: [
        {
          title: '获得质子的途径，包括但不限于以下几种：',
          content: [
            '积极参与微信群内活动，将有机会获得质子奖励。',
            '新用户注册后赠送50个质子。',
            '刷题，每做对1道题赠送1个质子。',
            '新用户完善个人信息，赠送50个质子。',
            '签到，每次签到赠送1个质子，连续签到有额外赠送。'

          ]
        },
        {
          title: '消耗质子的途径，包括但不限于以下几种：',
          content: [
            '直播过程中赠送直播礼物。',
            '用于获取题目解析。',
            '用于课程资料下载。',
            '在质子商城中兑换礼品（即将开放）。'
          ]
        }
      ],
      warn: ''
    }
  },
  methods: {
    getProton () {
      const phone = this.form.phone
      if (!phone) {
        this.warn = '请填写手机号'
        return false
      } else if (phone.length !== 11 || isNaN(phone) || !(/^1\d{10}$/.test(phone))) {
        this.warn = '请正确填写手机号'
        return false
      } else {
        const params = {
          // 上传的激励ID
          excitation_id: this.$route.params.excitationId,
          mobile: phone
        }
        if (this.$route.params.excitationConfId) {
          // 奖励配置模板id
          params.excitation_config_id = this.$route.params.excitationConfId
        }
        api
          .getProton(params)
          .then((res) => {
            if (res.data.code === 1) {
              this.protonNumber = res.data.data.number
              this.getState = true
            } else if (res.data.code === 60001) {
              this.isRegister = true
            } else {
              this.$message.warning(res.data.message)
            }
          })
      }
    }
  },
  watch: {
    'form.phone': {
      handler: function () {
        if (this.form.phone) {
          this.clearState = true
        } else {
          this.clearState = false
        }
      }
    }
  },
  mounted () {
    $('#footer').hide()
    $('.box-active1').hide()
    $('.banner').hide()
    $('aside').hide()
    this.$nextTick(() => {
      $('.el-main').css('background', 'white')
    })
    this.zhixinUrl = process.env.VUE_APP_ZHIXIN_URL
  },
  beforeDestroy () {
    $('.el-main').css('background', '')
    window.removeEventListener('beforeunload', (e) => this.beforeunloadFn(e))
  }
}
</script>
<style lang="scss">
@import "@/assets/scss/_base.scss";
.public-bck{
  background: $pagination-bg;
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 20;
  left: 0;
  top: 0;
  overflow-y: scroll;
   .noregister{
        position: fixed;
        width: 100%;
        height: 100%;
        background:rgba(0,0,0,0.3);
        z-index: 21;
        left: 0;
        top: 0;
        .noregister-pop{
            max-width: 246px;
            height: 262px;
            margin: auto;
            margin-top: 188px;
            position: relative;
            .noregister-img{
                width:127px;
                height:41px;
                position: absolute;
                top: -8px;
                left: 62px;
            }
            .noregister-close-img{
                width:25px;
                height:25px;
                position: absolute;
                right: -36px;
                top: -37px;
                cursor: pointer;
            }
            .noregister-content{
                background: $pagination-bg;
                border-radius: 8px;
                padding: 64px 0px 24px 0px;
                text-align: center;
                p:nth-child(1){
                    font-size: 19px;
                    font-weight: 500;
                }
                p:nth-child(2){
                    font-size: 14px;
                    color: $gray-dark;
                    margin: 24px 0px 40px;
                }
                a{
                    display: inline-block;
                    box-sizing: border-box;
                    padding: 8px 21px;
                    background: $brand-success;
                    color: $pagination-bg;
                    border-radius: 24px;
                }
            }
        }
    }
    .proton-bck{
        max-width: 600px;
        margin: auto;
        background: skyblue;
        padding-bottom: 18px;
        background: linear-gradient(180deg, $brand-warning 0%, #FFC837 100%);
        .bck-top{
        height: 120px;
        background: url("~@/assets/img/public/proton/top@2x.png") no-repeat;
        background-size: 100% 100%;
        }
        .proton-content, .proton-content-bottom,.proton-getsuccess{
            width: 91.67%;
            margin: auto;
            background-color: $pagination-bg;
            border-radius: 16px;
            margin-top: -105px;
            padding: 42px 17px 32px;
            box-sizing: border-box;
            text-align: center;
            margin-bottom: 16px;
            p{
                font-size: 24px;
                font-weight: 600;
                text-align: center;
                margin-bottom: 8px;
            }
            .proton-img{
                text-align: center;
                img{
                    margin-bottom: 24px;
                    max-width: 161px;
                    max-height: 122px;
                    margin-top: 30px;
                }
                h1{
                color: $font-brown;
                font-weight: 600;
                font-size: 28px;
                }
                h2{
                margin: 24px 0px 20px;
                color: $brand-warning;
                }
                p{
                    font-size: 12px;
                    font-weight: 400;
                    color: rgba($base-color, 0.6);
                }
            }
            .el-button{
                width: 89%;
                border-radius: 24px;
                padding: 10px 0px;
                font-size: 16px;
                margin: auto;
                box-shadow: 0px 3px 7px 0px rgba(255, 165, 13, 0.48);
            }
            .el-form{
                display: flex;
                .form-lable{
                    margin: 37px 0px 0px 0px;
                    width: 57px;
                    font-size: 14px;
                    color: $gray-dark;
                }
                .warn{
                    color: red;
                    text-align: left;
                    margin: 8px 0px 8px;
                    span{
                        position: relative;
                        top: 3px;
                    }
                }
                .form_phone {
                    width: 100%;
                    height: 46px;
                    border-radius: 4px;
                    border: 1px solid rgba($base-color, 0.08);
                    padding: 0px 8px 0px 12px;
                    display: flex;
                    align-items: center;
                    margin: 24px 0px 0px 0px;
                    .phone_input {
                    width: 83%;
                    .el-input__inner {
                        border: none;
                        padding: 0px 8px;
                        font-size: 16px;
                        color: $base-color;
                        cursor: pointer;
                    }
                    }
                    // .phone_codeinput {
                    // width: 70%;
                    // ::v-deep .el-input__inner {
                    //     border: none;
                    //     padding: 0px 8px;
                    //     font-size: 16px;
                    //     color: $base-color;
                    //     cursor: pointer;
                    // }
                    // }
                    // .phone_code {
                    // font-size: 14px;
                    // color: $brand-success;
                    // text-align: center;
                    // border-left: 1px solid rgba($base-color, 0.06);
                    // padding-left: 0.9rem;
                    // .el-button--primary {
                    //     color: $brand-success;
                    //     background: $pagination-bg;
                    //     border: none;
                    // }
                    // }
                    .phone_pre {
                    font-size: 16px;
                    font-weight: 400;
                    color: $base-color;
                    }
                    .phone_clear {
                    cursor: pointer;
                    width: 24px;
                    height: 24px;
                    }
                }
            }

        }
        .proton-getsuccess{
        background: url("../../assets/img/public/proton/success_bck@3x.png") $pagination-bg no-repeat;
        background-size: 100% 199px;
        padding: 73px 17px 32px;
        }
        .proton-content-bottom{
            margin-top: 0px;
            padding: 21px 17px 18px;
            font-size: 12px;
            text-align: left;
            .tip-top{
                height: 17px;
                background: url("~@/assets/img/public/proton/title@3x.png") no-repeat;
                background-size: 100% 100%;
                text-align: center;
                font-size: 15px;
                margin-bottom: 18px;
                font-weight: 500;
            }
            .tip-lists{
                margin-bottom: 24px;
            }
            .tip-tipsinfo{
                margin-top: 8px;
                color: rgba($base-color, 0.6);
            }
        }
    }
}
@media (min-width: 414px) {
.public-bck {
    .proton-bck {
        .proton-content-bottom{
            .tip-top{
                height: 25px;
                line-height: 29px;
            }
        }
    }
}
}
</style>
